import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccApplicationWithSortingScore } from '@interfaces';
import { DomainDataService } from '../../../../../services';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsProspectsService } from '../../../prospects/admissions-prospects.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'prospects-all-applications-view-part',
	standalone: true,
	templateUrl: './all-applications.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [GridContentWidget],

})
export class AllApplicationsViewPart {
	private readonly domainDataService = inject(DomainDataService);
	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AdmissionsProspectsService);
	private readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.util, this.domainDataService, this.dialogService, this.admissionsAreaService.app, this.admissionsAreaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accApplications = computed<AccApplicationWithSortingScore[]>(() => (this.admissionsAreaService.admissionsData()?.accApplications ?? [])
		.sort((a, b) => b.sortingScore - a.sortingScore)
	);

}
